import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  modalContainer: {
    paddingHorizontal: 0,
    marginBottom: 0,
    paddingBottom: 0,
  },
  modalContentWraper: theme => ({
    flexGrow: 1,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  verticalSpacing: {
    marginVertical: 16,
    paddingHorizontal: 16,

  },
  descText: {
    // marginBottom: 16,
    // paddingHorizontal: 16,
  },
  //Location
  mylocationContainer: theme => ({
    flexGrow: 1,
    minHeight: 450,
    backgroundColor: theme.colors.cardBackgroundColor,
    elevation: 5,
    borderRadius: 7,
    shadowColor: Colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.16,
    shadowRadius: 8,
  }),
  mapContainer: theme => ({
    position: 'relative',
    flex: 1,
    width: '100%',
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
    backgroundColor: theme.colors.cardBackgroundColor,
    overflow: 'hidden',
  }),
  map: {
    ...StyleSheet.absoluteFillObject,
  },
  currentLocationButton: {
    padding: 16,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: 50,
  },
  currentLocationText: {
    paddingBottom: 3,
  },
  locationError: {
    marginHorizontal: 32,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  currentLocationErrorText: {
    flexGrow: 1,
    flexShrink: 1,
  },
  confirmButton: {
    margin: 16,
    marginBottom: 32,
  },
  btnWrapper: (buttonPosition = 'bottom') => {
    const postion = {
      bottom: {
        bottom: 25,
      },
      top: {
        top: 15,
      },
    }

    return {
      // elevation: 5,
      // borderRadius: 7,
      // shadowColor: Colors.black,
      // shadowOffset: {
      //   width: 0,
      //   height: 2,
      // },
      // shadowOpacity: 0.16,
      // shadowRadius: 8,
      position: 'absolute',
      alignSelf: 'center',
      padding: 16,
      paddingTop: 14,
      paddingBottom: 5,
      marginHorizontal: 15,
      ...postion[buttonPosition],
    }

  },
  button: {
    width: '90%',
    paddingTop: 12,
    paddingBottom: 12,
  },
  inputWrapper: theme => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  searchInputContainer: theme => ({
    flex: 1,
    marginBottom: 0,
    marginHorizontal: 0,
    marginTop: 0,
    marginRight: 10,
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  searchIconContainer: {
    backgroundColor: 'red',
    borderRadius: 6,
    flex: 1,
    maxHeight: 55,
    alignItems: 'center',
    maxWidth: 55,
    justifyContent: 'center',
  },
  //Notify
  primaryButton: {
    margin: 16,
  },
  secondaryButton: {
    marginHorizontal: 16,
    marginBottom: 32,
  },
  //Loader
  loaderWrapper: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    zIndex: 2,
    backgroundColor: 'transparent',
  },
  textInput: theme => ({
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.input,
    backgroundColor: 'transparent',
    color: theme.colors.textColor,
    marginLeft: -5,
    width: '100%',
    flex: 1,
    textAlignVertical: 'center',
    marginBottom: -8,
  }),
  rowContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  description: theme => ({
    color: theme.colors.textColor
  }),
  seperator: theme => ({
    backgroundColor: theme.colors.borderColorThree,
  }),
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    // paddingHorizontal: 16,
    // marginVertical: 20,
  },
  notifyContainer: theme => ({
    position: 'absolute',
    bottom: 0,
    flex: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    padding: 20,
    margin: 20,
    borderRadius: 6,
  })
})

export default styles
